import { Component, Input, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { finalize, first, map, mergeMap, of, pipe, take } from "rxjs";
import { ValidateCartModalComponent } from "src/app/features/dashboard/accounts/modals/validate-cart-modal/validate-cart-modal.component";
import { ServicesService } from "src/app/features/dashboard/accounts/pages/service/services.service";
import { Eventservice } from 'src/app/features/http-services/events.service';
import { SharedService } from "src/app/features/http-services/shared.service";
import { StorageService } from "src/app/features/http-services/storage.service";
import { TokenService } from "src/app/features/http-services/token.service";
import { profileTab } from "../../../constants/profileTab";
import { environment } from "src/environments/environment";
import { ApiService } from "src/app/features/http-services/api.service";
import { SessionService } from "src/app/features/http-services/session.service";
import { UserService } from "src/app/features/dashboard/user/services/user.service";

@Component({
  selector: "bx-header",
  templateUrl: "./bx-header.component.html",
  styleUrls: ["./bx-header.component.scss"],
})
export class BxHeaderComponent implements OnInit {
  modalRef!: BsModalRef;
  @Input() showBuilderInfo: boolean = true;
  menuRight: Array<any> = [];
  miniCartCount: any = {};
  accountDropdownItems: Array<any> = [];
  builderDetails: any = {};
  isMultiAccount:boolean=false;
  showXchangeCTA=true;
  showCart = true;
  private duplicateLoginPollInterval: any;
  constructor(
    private storageServcie: StorageService,
    private tokenService: TokenService,
    private sharedService: SharedService,
    private router: Router,
    private csrService: ServicesService,
    private modalService: BsModalService,
    private eventservice: Eventservice,
    private apiService: ApiService,
    private sessionService: SessionService,
    private userService: UserService
  ) {
    this.router.events.subscribe((val) => {
      this.dataUp();
    });
  }


  builderDetails$ = this.storageServcie
    .getItem("selected-builder")
    .pipe(first());

  logout() {
    if (sessionStorage.getItem("startSession")) {
      this.sessionService.logout();
    }
    else
    {
    this.storageServcie.getItem("customer-details")
    .pipe(take(1))
    .subscribe(res => {
      if (res?.isCSR) {
        this.userService.setDefaultUnit({ username: res?.uid})
        .pipe(finalize(() => this.tokenService.logout())).subscribe()
      } else {
        this.tokenService.logout()
      }
      
    })
    }
  }
  getOrgCustomers() {
    return this.storageServcie.getItem("customer-details")
    .pipe(
      take(1),
      mergeMap((data) => this.sharedService.getOrgCustomers({
        userId: data?.uid,
        accoundUid: data?.orgUnit?.uid
      }))
    )
  }
  ngOnInit(): void {
    this.accountDropdownItems = profileTab;
    this.storageServcie.getItem("cart").subscribe((res) => {
      if (Object.keys(res || {}).length > 0) {
        this.miniCartCount = res;
      }
    });
    this.apiService.miniCartSubject.subscribe((res) => {
      // if (Object.keys(res || {}).length > 0) {
        this.miniCartCount = res;
      // }
    });
    this.dataUp();
    this.storageServcie.getItem("customer-details").subscribe(() => this.dataUp());
    this.builderDetails$.subscribe({
      next: res => this.builderDetails = res || {}
    });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.builderDetails$.subscribe({
          next: res => this.builderDetails = res || {}
        }); 
      }
    });
    this.storageServcie.getItem("is-multi-accounts").subscribe(res => {
      if(res) {
        const profileTabs = this.accountDropdownItems;
        profileTabs.splice(1, 0, {
            name: 'Accounts',
            path: '/multiple-accounts'
        });
        this.accountDropdownItems = profileTabs;
      }
    });

    this.sharedService.getSetSyncWithIndexDB().subscribe((res) => {
      console.log("SYNCING_WITH_INDEX_DB");
      this.dataUp();
    });
    this.getOrgCustomers()
    .pipe(take(1))
    .subscribe({
      next: res => {
        const address = res?.[0]?.addresses?.[0];
        this.storageServcie.setItem("customer-address", address || "");
        setTimeout(() => this.dataUp(), 1000);
      }
    })
  
    this.sharedService.onHeaderUpdate().subscribe(() => {
      this.getOrgCustomers()
      .pipe(take(1))
      .subscribe({
        next: res => {
          const address = res?.[0]?.addresses?.[0];
          this.storageServcie.setItem("customer-address", address || "");
          setTimeout(() => this.dataUp(), 1000);
        }
      })
    });
  }
  dataUp(){
    this.storageServcie
    .getItem(["customer-details", "customer-address","salesman-selected"])
    .pipe(first(), map(([customerDetails, customerAddress,salesmanSelected]) => ({
      ...customerDetails,
      customerAddress,salesmanSelected
    }))).subscribe(({salesmanSelected, isCSR, defaultAddress, orgUnit,accountList, isSalesPerson, isSalesOps, customerAddress, isCustomer, accounts, isALCBDM }) => {
      this.isMultiAccount=accountList;
      this.menuRight = [
        {
          name: orgUnit?.name || "",
          icon: orgUnit?.uid !== "EMPTY_B2BUNIT",
          link: "",
        },
        {
          // name: `Account # ${orgUnit?.uid  ? "" : orgUnit?.accountType  || ""}.${(orgUnit?.uid || "").split("_")[0]}.${orgUnit?.suffix || ""}`,
          name: `Account # ${orgUnit?.uid === "EMPTY_B2BUNIT" ? "EMPTY_B2BUNIT" : (orgUnit?.uid || "").split("_")[0] * 1}`,
        },
        {
          name: salesmanSelected ? salesmanSelected.formattedAddress : customerAddress?.formattedAddress || "",
        },
      ];

      if (isCustomer && (accounts?.length || []) > 1 && (orgUnit?.uid !== 'EMPTY_B2BUNIT' && orgUnit?.uid !== '')) {
        this.menuRight.push({ type: 'exit', name: 'Exit', listIcon: "bi bi-chevron-right" })
      }

      if ((isCSR) && orgUnit?.uid !== 'EMPTY_B2BUNIT') {
        this.menuRight.push({ type: 'exit', name: 'Exit', listIcon: "bi bi-chevron-right" })
      }
      if (isSalesPerson || isSalesOps || isALCBDM ) {
        this.storageServcie.getItem(["salesman-selected"])
          .pipe(take(1))
          .subscribe(([salesmanSelected]) => {
            if ((salesmanSelected) && !this.menuRight.some((item) => item.type === 'exit')) {
              this.menuRight.push({ type: 'exit', name: 'Exit', listIcon: "bi bi-chevron-right" })
            }
            this.showCart = salesmanSelected;
            this.showXchangeCTA = salesmanSelected === 1;
        });
      }
      if (isCSR) {
        this.accountDropdownItems = this.accountDropdownItems.map((item: any) => {
          if (item?.path === "/my-profile") {
            item.isDisabled = orgUnit?.uid === 'EMPTY_B2BUNIT'
          }
          return {
            ...item,
          }
        });
      }
      if (isSalesPerson || isSalesOps) {
        const isShipToUser = orgUnit?.accountType === "ZMSH";
        const profileTabs = this.accountDropdownItems;
        const isSlaesmanOptionExist = profileTabs.some((item => item.name === "Salesperson Dashboard"));
        const isSlaesmanAccountsExist = profileTabs.some((item => item.name === "Accounts"));

        if (isSalesOps) {
          if (!isSlaesmanAccountsExist) {
            profileTabs.splice(1, 0, {
              name: 'Accounts',
              path: '/salesman-view-account'
            });
          } 
        } else {
          if (!isSlaesmanOptionExist && !isShipToUser) {
            profileTabs.splice(1, 0, {
              name: 'Accounts',
              path: '/salesman-view-account'
            },
            {
              name: 'Salesperson Dashboard',
              path: '/salesman-dashboard'
          });
          }
        }
        this.accountDropdownItems = profileTabs;
      }
      this.storageServcie.getItem(["selected-builder"])
        .pipe(take(1))
        .subscribe(([selectedBuilder]) => {
          if(!selectedBuilder){
            this.accountDropdownItems = this.accountDropdownItems.map((item: any) => {
              if (item?.path === "/shipping-preferences") {
                item.isDisabled = true
              }
              if (item?.path === "/billing-address") {
                item.isDisabled = true
              }
              return {
                ...item,
              }
            });
          }
          else {
            this.accountDropdownItems = this.accountDropdownItems.map((item: any) => {
              if (item?.path === "/shipping-preferences") {
                item.isDisabled = false
              }
              if (item?.path === "/billing-address") {
                item.isDisabled = false
              }
              return {
                ...item,
              }
            })
          }
        })
        
    });
    this.builderDetails$.subscribe({
      next: res => {
        this.builderDetails = res || {}
      }
    });
  }

  handleAccountInfoClick(type:string){
      if(type === 'exit'){
        this.sharedService.triggerHeaderUpdate()
        this.storageServcie.getItem(["customer-details", "cart"])
        .pipe(take(1))
        .subscribe(([customerDetails, cart]) => {
          if (cart?.totalItems && !(customerDetails?.isSalesPerson || customerDetails?.isSalesOps)) {
            this.openValidateCSRCartModal({
              cartId: cart.code,
              userId: customerDetails?.uid
            });
          } else {
            if (customerDetails?.isSalesPerson || customerDetails?.isSalesOps || customerDetails?.isALCBDM) {
              this.storageServcie.removeItem("cart");
              this.sharedService.setMiniCartValue({ code: null, totalItems: 0 });
              this.router.navigate(['/salesman-dashboard']);
            } else {
              if (customerDetails?.isCustomer && (customerDetails?.accounts || []).length > 1) {
                this.router.navigate(['/multiple-accounts'], { queryParams: { exit: true }})
              } else {
                this.router.navigate(['/csr'], { queryParams: { exit: true }})
              }
            }
            this.dataUp();
          }
        })
        // this.router.navigate(['/csr'], { queryParams: { exit: true }})
        // this.dataUp()
      }
      // if(name.includes('Account #') && this.isMultiAccount){
      //   this.router.navigate(['/multiple-accounts'])
      //   this.dataUp()
      // }
    }

    handleLogoClick() {
      this.eventservice.internalLinkClicked({
        linkContainer: 'Global Header',
        linkId: 'Home',
        linkTarget: '/',
      });
      this.storageServcie.getItem(["customer-details", "salesman-selected"])
      .pipe(take(1))
      .subscribe(([customerDetails, salesmanSelected]) => {
        const isShipToUser = customerDetails?.orgUnit?.accountType === "ZMSH";
        this.router.navigate([(((customerDetails?.isSalesPerson && !isShipToUser) || (customerDetails?.isSalesOps || customerDetails?.isALCBDM)) && !salesmanSelected) ? "/salesman-dashboard" : "/"]);
      });
      
    }

    openValidateCSRCartModal(data = {}) {
      const initialState: ModalOptions = {
        backdrop: true,
        ignoreBackdropClick: true,
        initialState: {
          ...data,
        },
      };
      this.modalRef = this.modalService.show(
        ValidateCartModalComponent,
        Object.assign(initialState, { class: `modal-md modal-dialog-centered` })
      );
    }

    getAvatarLabel(name: any = "") {
      const nameArr = (name || "").split(" ");
      return `${nameArr?.[0]?.[0] || ""}${nameArr?.[1]?.[0] || ""}`
    }

    gotoMohawkXchange() {
      window.open(environment.mohawkXchangeAppUrl, "_blank");
    }
  
}